import { useQuery } from '@tanstack/react-query'
import { DOCS_MANIFEST_URL } from './docsConstants'
import type { DocsManifest } from './docsTypes'

async function fetchDocsManifest(): Promise<DocsManifest> {
  const response = await fetch(DOCS_MANIFEST_URL)
  if (!response.ok) {
    throw new Error('Failed to load documentation manifest')
  }
  return response.json() as Promise<DocsManifest>
}

export function useDocsManifest() {
  return useQuery({
    queryKey: ['docs-manifest'],
    queryFn: fetchDocsManifest,
    staleTime: Infinity,
  })
}
